import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { Category } from '@app/model/catetory';
import { UserService } from '../user-service/user.service';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  category: Category = new Category('', '', '', '', false, false, [], '', 0, '');
  private supabaseClient: SupabaseClient;

  constructor(private userService: UserService) {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getAllCategory() {
    const res = await this.supabaseClient.from('category').select('*');
    return res;
  }

  async getCategoryById(categoryId: string) {
    const res = await this.supabaseClient.from('category').select('*').eq('id', categoryId);
    return res;
  }

  async getActivateUsersIdByCategoryId(CategoryId: string) {
    const res = await this.supabaseClient.from('category').select('activate_users').eq('id', CategoryId);
    return res;
  }

  async createCategory(category: Category) {
    const res = await this.supabaseClient.from('category').insert([
      {
        color: category.color,
        title: category.title,
        description: category.description,
        need_pro: category.need_pro,
        activate_users: category.activate_users,
      }
    ]);
    return res;
  }

  async updateCategory(category: Category) {
    const res = await this.supabaseClient.from('category').update({
      color: category.color,
      title: category.title,
      description: category.description,
      need_pro: category.need_pro,
      activate_users: category.activate_users,
      is_available: category.is_available,
    }).eq('id', category.id);
    return res;
  }

  // 新使用者自動加入所有不需專業審核的大類別與小類別
  async joinOpenCategories() {
    const { error } = await this.supabaseClient.rpc('join_open_categories');
    if (error) throw error;
  }

  async getAvailableCategories() {
    const userId = await this.userService.getUserId();
    const res = await this.getAllCategory();
    const categories: Category[] = [];
    res?.data?.forEach((category: any) => {
      if (category.activate_users.includes(userId)) {
        categories.push(category);
      }
    });
    return categories;
  }

  async checkIsAvailableForPro(categoryId: any) {
    const userId = await this.userService.getUserId();
    const res = await this.getCategoryById(categoryId);
    if (res?.data?.[0].activate_users.includes(userId)) {
      return true;
    } else {
      return false;
    }
  }

  async addActivateUser(categoryId: any, userId: any) {
    const res = await this.getCategoryById(categoryId);
    const activateUsers = res?.data?.[0].activate_users;
    activateUsers.push(userId);
    await this.supabaseClient.from('category').update({
      activate_users: activateUsers,
    }).eq('id', categoryId);
  }

  async deleteCategory(categoryId: string) {
    const res = await this.supabaseClient.from('category').delete().eq('id', categoryId);
    return res;
  }

}
